// Next.js'in istemci çoklu dolgu modülünün (next/dist/build/polyfills/polyfill-module) yerine (next.config.ts →
// turbopack.resolveAlias). Özgün modüldeki dolguların (String trimStart/trimEnd, Symbol.description, Array flat/flatMap/at,
// Promise.finally, Object.fromEntries/hasOwn) hepsi Next'in desteklediği tarayıcılarda (Chrome/Edge/Firefox 111+,
// Safari 16.4+) yerleşik; Lighthouse bunları "Eski JavaScript" olarak sayıyordu. Yalnızca URL.canParse kalır:
// Safari 17'den önce yok (React/Next kullanıyor).
if (typeof URL !== "undefined" && !("canParse" in URL)) {
  URL.canParse = function canParse(url, base) {
    try {
      return !!new URL(url, base);
    } catch {
      return false;
    }
  };
}
